import React, { useEffect } from "react";
import { Avatar, Box, IconButton, Tab } from "@mui/material";
import Slider from "react-slick";
import {
  AppDetailTabs,
  AppDetailWrapper,
  HtmlContentWrapper,
} from "./AppDetailStyles";
import AppButton from "../../../AppComponents/AppButton";
import { AppMaterialIcons } from "../../../AppComponents/AppMaterialIcons";
import useModal from "../../../Hooks/useModel/useModel";
import NavigationBar from "../NavigationBar";
import CarouselModal from "./AppCarouselModal";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../Store";
import { AppActions } from "../../../Store/Slices/AppStore/appStore.action";
import {
  selectAppStatus,
  selectSelectedApp,
  selectAppError,
} from "../../../Store/Slices/AppStore/appStore.selector";
import axios from "axios";
import { coreAxios } from "../../../Utils";
import { useNotification } from "../../../Hooks/useNotification/useNotification";
import { LoaderComponentProps, withLoader } from "../../../AppComponents/Loader";
interface Props extends LoaderComponentProps {}

const AppDetail: React.FC<Props> = ({ setLoading }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>(); // Get app ID from URL
  const appDetail = useAppSelector(selectSelectedApp);
  const appStatus = useAppSelector(selectAppStatus);
  const appError = useAppSelector(selectAppError);
  const { showAlert } = useNotification();
  const [index, setIndex] = React.useState(0);
  const { isShowing: isCarouselModalOpen, toggle: toggleCarouselModal } =
    useModal();

  useEffect(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    if (id) {
      dispatch(AppActions.fetchAppDetails(id));
    }
  }, [id, dispatch]);
  const onTabClicked = (event: React.SyntheticEvent, newIndex: number) => {
    setIndex(newIndex);
  };
  if (appStatus === "loading") {
    return <div>Loading...</div>;
  }
  if (appStatus === "failed") {
    return <div>Error: {appError}</div>;
  }
  const handleUninstallClick = () => {
    setLoading(true);
    coreAxios.post(`/workspace/app-store/${id}/auth-disconnect`, {}).then((res: any) => {
      // console.log(res);
      showAlert(
        res?.data?.message || "App uninstalled successfully",
        "success"
      );
      if (id) {
        dispatch(AppActions.fetchAppDetails(id));
      }
    })
    .catch((err) => {
      // console.log(err);
      showAlert(
        err?.response?.data?.error || "Unable to fetch Data",
        "error"
      );
    })
    .finally(() => {
      // console.log("Finally");
      setLoading(false);
    });
  }
  return (
    <AppDetailWrapper>
      <NavigationBar list={["App Store", appDetail?.title]} />
      <Box className="container">
        <Box className="detail__left">
          <Box className="left__wrapper">
            <Box className="app__data" display="flex" flexWrap="wrap">
              <Box className="app__detail" flex="1" minWidth="50%">
                <Box className="details">
                  <Avatar
                    sx={{
                      "& img": {
                        objectFit: "scale-down",
                        padding: "5px",
                      },
                    }}
                    alt="Image 1"
                    src={appDetail?.icon}
                  />
                  <Box className="app__detail__header">{appDetail?.title}</Box>
                  <Box className="app__desc">{appDetail?.description}</Box>
                  <Box className="install__btn">
                    {!appDetail?.is_installed ?
                    <AppButton
                    onClick={() =>
                      navigate(`/app-store/install/${appDetail?.name}?appid=${appDetail?.id}`)
                    }
                    variant="primarydark"
                  >
                    Install
                  </AppButton>:
                   <AppButton
                   variant="primarydark"
                   onClick={()=> handleUninstallClick()}
                 >
                   Uninstall
                 </AppButton>
                    }
                    
                    {/* <IconButton>
                      <AppMaterialIcons iconName="SettingsOutlined" />
                    </IconButton> */}
                  </Box>
                </Box>
              </Box>
              <Box className="app__images" flex="1" minWidth="50%">
                <Box className="slider__wrapper">
                  <Slider
                    arrows={false}
                    dots={true}
                    infinite={false}
                    speed={500}
                    slidesToShow={1}
                    slidesToScroll={1}
                  >
                    {appDetail?.images.map(
                      (
                        i: string | undefined,
                        index: React.Key | null | undefined
                      ) => (
                        <Box className="slide" key={index}>
                          <img
                            style={{
                              aspectRatio:"4/3"
                            }}
                            onClick={() => toggleCarouselModal()}
                            src={i}
                            alt={`slide-${index}`}
                          />
                        </Box>
                      )
                    )}
                  </Slider>
                  <CarouselModal
                    open={isCarouselModalOpen}
                    onClose={toggleCarouselModal}
                    images={appDetail?.images || []}
                  />
                </Box>
              </Box>
            </Box>
            <Box className="app__info">
              <AppDetailTabs value={index} onChange={onTabClicked}>
                <Tab label="Overview" />
                <Tab label="How to Install" />
                <Tab label="Privacy and Security" />
              </AppDetailTabs>
              <Box className="body">
                <HtmlContentWrapper
                  dangerouslySetInnerHTML={{
                    __html:
                      index === 0
                        ? appDetail?.sections?.overview
                        : index === 1
                        ? appDetail?.sections?.how_to_install
                        : appDetail?.sections?.privacy_and_security,
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </AppDetailWrapper>
  );
};
export default withLoader(AppDetail);